//
// Action Types
//

export const NODE_TOGGLE = 'pro/treeview/NODE_TOGGLE';
export const NODE_EXPAND = 'pro/treeview/NODE_EXPAND';
export const NODE_CLOSE = 'pro/treeview/NODE_CLOSE';

//
// Action Creators
//
export const nodeExpand = nodeId => ({
  type: NODE_EXPAND,
  nodeId,
});

export const nodeClose = nodeId => ({
  type: NODE_CLOSE,
  nodeId,
});

export const nodeToggle = nodeId => ({
  type: NODE_TOGGLE,
  nodeId,
});
